import {
  ChemicalActionBtnRenderer,
  ChemicalCategroyRenderer,
  ChemicalConentrationRenderer,
  ChemicalDensityRenderer,
  ChemicalPlantCostRenderer,
  ChemicalDropdownRenderer,
} from "../ChemicalTableRenderer";
import { FEATURE_SCOPE } from "../../../constants/global.constants";
import { CHEMICAL_PRICE_MAX_FRACTIONS } from "../chemicalLibrary.constants";
import { convertUptoDigits } from "../../../utils/appUtils";

export const CHEMICAL_LIB_TABLE_CONFIG = (t, scope) => [
  {
    id: 1,
    headerName: t("chemicalLibrary.displayLabel"),
    field: "display_name",
    width: 140,
    tooltip: true,
    cellStyle: { fontWeight: 600 },
    flex: 1,
  },
  {
    id: 2,
    headerName: t("chemicalLibrary.chemical"),
    field: "chemical",
    width: 200,
    tooltip: true,
    flex: 1.75,
  },
  {
    id: 3,
    headerName: t("chemicalLibrary.concentration"),
    field: "bulk_concentration",
    width: 110,
    valueFormatter: (params) => `${params.value}%`,
    cellRenderer: ChemicalConentrationRenderer,
    flex: 1,
  },
  {
    id: 4,
    headerName: t("chemicalLibrary.category"),
    field: "category",
    width: 100,
    cellRenderer: ChemicalCategroyRenderer,
    flex: 1,
  },
  {
    id: 5,
    headerName: t("chemicalLibrary.symbol"),
    field: "symbol",
    width: 100,
    tooltip: true,
    flex: 1,
  },
  {
    id: 6,
    headerName: t("chemicalLibrary.density"),
    field: "bulk_density",
    width: 125,
    cellRenderer: ChemicalDensityRenderer,
    flex: 1,
  },
  {
    id: 7,
    headerName: t("chemicalLibrary.price"),
    field: "price",
    width: 100,
    flex: 1,
    ...(scope === FEATURE_SCOPE.PLANT
      ? {
          cellRenderer: ChemicalPlantCostRenderer,
        }
      : {
          valueFormatter: (params) =>
            `${convertUptoDigits(params.value, CHEMICAL_PRICE_MAX_FRACTIONS)}`,
        }),
  },
  {
    id: 8,
    headerName: t("chemicalLibrary.type"),
    field: "unit",
    width: 65,
    flex: 0.75,
    ...(scope === FEATURE_SCOPE.PLANT
      ? {
          cellRenderer: ChemicalDropdownRenderer,
        }
      : {}),
  },
  ...(scope === FEATURE_SCOPE.USER
    ? [
        {
          id: 10,
          headerName: t("chemicalLibrary.actions"),
          field: "actions",
          cellRenderer: ChemicalActionBtnRenderer,
          width: 106,
          flex: 0.75,
        },
      ]
    : []),
];
